function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-setton-2x-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-setton-2x-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C3CACF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8E8F9B",
  offset: "57.569%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8C8F99",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-setton-2x-c",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-setton-2x-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-setton-2x-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#avatar-setton-2x-b)",
  mask: "url(#avatar-setton-2x-c)",
  d: "M43.312 78.2c-6.952 0-12.587-5.635-12.587-12.586V38.93c0-.64-.52-1.157-1.157-1.157h-8.206c-1.926 0-3.488-1.562-3.488-3.49v-2.07c0-1.925 1.562-3.487 3.488-3.487h8.206c.638 0 1.157-.518 1.157-1.157v-7.36c0-1.93 1.562-3.49 3.488-3.49h3c1.927 0 3.49 1.56 3.49 3.49v7.353c0 .638.517 1.156 1.156 1.156h31.09c2.06 0 3.733 1.673 3.733 3.736v11.32c0 7.82-6.34 14.16-14.16 14.16H54.79c-1.746 0-3.162-1.417-3.162-3.163v-2.42c0-1.747 1.416-3.163 3.162-3.163h4.057c4.12 0 7.46-3.34 7.46-7.456V39.28c0-.833-.68-1.51-1.513-1.51h-22.94c-.638 0-1.156.52-1.156 1.158v24.7c0 2.85 2.31 5.16 5.16 5.16H85.9c1.435 0 2.6-1.164 2.6-2.6V24.115c0-9.73-7.886-17.615-17.614-17.615H24.114C14.386 6.5 6.5 14.386 6.5 24.114v46.772c0 9.728 7.886 17.614 17.614 17.614h46.772c6.046 0 11.388-3.064 14.56-7.72.746-1.094-.047-2.58-1.372-2.58H43.312"
}));

var SvgSettonDark = function SvgSettonDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettonDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/setton-dark.2d51dbfc.svg";
export { ForwardRef as ReactComponent };